// residency status
export enum RESIDENCY_STATUS {
  CITIZEN = 'citizen',
  PR = 'pr',
  VISA = 'visa',
}
export const residencyStatusOptions = Object.values(RESIDENCY_STATUS)
export type ResidencyStatus = (typeof residencyStatusOptions)[number]
export const residencyStatusMap = {
  [RESIDENCY_STATUS.CITIZEN]: 'Australian citizen',
  [RESIDENCY_STATUS.PR]: 'Permanent resident',
  [RESIDENCY_STATUS.VISA]: 'Temporary Visa',
}

// refactored residency status
export enum REF_RESIDENCY_STATUS {
  PR = 1,
  CITIZEN = 2,
  VISA = 3,
}
export const refResidencyStatusOptions = Object.values(REF_RESIDENCY_STATUS)
export type RefResidencyStatus = (typeof refResidencyStatusOptions)[number]
export const refResidencyStatusMap = {
  [REF_RESIDENCY_STATUS.PR]: 'Permanent resident',
  [REF_RESIDENCY_STATUS.CITIZEN]: 'Australian citizen',
  [REF_RESIDENCY_STATUS.VISA]: 'Temporary Visa',
}
